import { Box, Text } from "@chakra-ui/core"
import React from "react"

interface Props {}

const ContactInfo: React.FC<Props> = () => {
  return (
    <Box color="gray.200" padding={6} backgroundColor="gray.900">
      <Text textAlign="center">
        Can’t find the answer you’re looking for? We want to help.
      </Text>
      <Text textAlign="center">
        Contact us via{" "}
        <Text
          as="a"
          href="mailto:madmustachecompany@gmail.com"
          fontWeight="bold"
          color="red.300"
        >
          email
        </Text>{" "}
        or reach out to us on{" "}
        <Text
          as="a"
          href="https://x.com/madmustachecom1"
          fontWeight="bold"
          color="red.300"
          target="_blank"
        >
          X
        </Text>
      </Text>
    </Box>
  )
}

export default ContactInfo
